var map = {
	"./compass-orang.png": 4598,
	"./compass.png": 8304,
	"./contact-list-orang.png": 1341,
	"./contact-list.png": 3323,
	"./documents-orang.png": 5172,
	"./documents.png": 7686,
	"./fire-orang.png": 4020,
	"./fire.png": 6326,
	"./friend-orang.png": 8732,
	"./friend.png": 4510,
	"./guitar-orang.png": 9794,
	"./guitar.png": 9804,
	"./leaderboard-orang.png": 515,
	"./leaderboard.png": 5961,
	"./play-button-orang.png": 9709,
	"./play-button.png": 251,
	"./subscriber-orang.png": 5730,
	"./subscriber.png": 2428,
	"./vinyl-orang.png": 118,
	"./vinyl.png": 7632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6961;